import * as React from 'react';

import { loadMoreHistory, WalletActionCreators } from 'actions/wallet';
import { Infinite } from 'components/Infinite';
import { WalletHistoryItem } from 'components/Wallet';
import { WalletTransactionList, WalletTransactionListFilter } from 'models/wallet';
import { FormattedMessage } from 'react-intl';

import './WalletHistory.scss';

interface WalletHistoryProps {
  data: WalletTransactionList;
  filter: WalletTransactionListFilter;
  isLoading: boolean;
  loadMoreHistory: typeof loadMoreHistory;
  updateTransactionListFilter: typeof WalletActionCreators.updateTransactionListFilter.create;
}

export class WalletHistory extends React.Component<WalletHistoryProps, {}> {
  constructor(props: WalletHistoryProps) {
    super(props);

    this.hasMoreHistoryData = this.hasMoreHistoryData.bind(this);
    this.loadMoreHistory = this.loadMoreHistory.bind(this);
  }

  componentDidMount() {
    this.loadMoreHistory();
  }

  render() {
    const { isLoading } = this.props;
    return (
      <div className="wallet-history">
        <span className="wallet-history__title">
          <FormattedMessage id="wallet.history.title"/>
        </span>
        <Infinite
          loadMore={this.loadMoreHistory}
          hasMore={this.hasMoreHistoryData()}
          isLoading={isLoading}
        >
        {this.walletHistories}
        </Infinite>
      </div>
    );
  }

  get walletHistories() {
    const { data, isLoading } = this.props;
    if (data.content.length === 0) {
      if (isLoading) {
        return null;
      } else {
        return (
          <div className="wallet-history-item__empty-content">
            <FormattedMessage id="wallet.history.empty"/>
          </div>
        );
      }
    }

    return data.content.map((transaction) => <WalletHistoryItem key={transaction.id} transaction={transaction} />);
  }

  private loadMoreHistory() {
    const { filter } = this.props;
    this.props.loadMoreHistory(filter);
  }

  private hasMoreHistoryData() {
    const { data } = this.props;
    return data.page.totalPages > 1;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Wallet/WalletHistory/WalletHistory.tsx